import { createAction } from 'redux-actions'

const SET_CONFIG = 'totalbalance/config/set'
const TOGGLE_THEME = 'totalbalance/config/TOGGLE_THEME'
const OPEN_MAIN_C_SELECTOR = 'totalbalance/config/OPEN_MAIN_C_SELECTOR'

const initialState = {
  enableDarkTheme: true,
  isSidebarOpen: false,
  mainCurrency: 'EUR',
  mainCurrencySelectorOpen: false,
}

export default function config(state = initialState, action) {
  switch (action.type) {
    case SET_CONFIG:
      return {
        ...state,
        ...action.payload,
      }
    case TOGGLE_THEME:
      return {
        ...state,
        enableDarkTheme: !state.enableDarkTheme,
      }
    case OPEN_MAIN_C_SELECTOR:
      return {
        ...state,
        mainCurrencySelectorOpen: true,
      }
    default:
      return state
  }
}

export const toggleTheme = createAction(TOGGLE_THEME)

export const setConfig = createAction(SET_CONFIG)

export const toggleSidebar = () => (dispatch, getState) =>
  dispatch(setConfig({ isSidebarOpen: !getState().config.isSidebarOpen }))

export const openMainCurrencySelector = createAction(OPEN_MAIN_C_SELECTOR)



// WEBPACK FOOTER //
// ./src/actions/config.js